import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var InfoIcon = function InfoIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return props.channel === 'sainsburys' ? /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "-2 -2 24 24",
    fill: fill
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM11.54 5.128C11.54 5.784 11.044 6.312 10.388 6.312C9.732 6.312 9.188 5.784 9.188 5.128C9.188 4.472 9.716 3.944 10.372 3.944C11.028 3.944 11.54 4.472 11.54 5.128ZM9.364 8.744H8.436V7.24H10.996C11.364 7.24 11.492 7.416 11.492 7.752V13.208C11.492 13.544 11.62 13.688 11.876 13.688C12.068 13.688 12.356 13.576 12.484 13.48L12.42 14.696C12.116 14.904 11.588 15.096 11.012 15.096C10.356 15.096 9.908 14.904 9.652 14.552C9.444 14.264 9.364 13.816 9.364 13.304V8.744Z"
  })) : /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15v-3h-.75a.75.75 0 1 1 0-1.5H12a.75.75 0 0 1 .75.75V15h.75a.75.75 0 1 1 0 1.5h-3a.75.75 0 1 1 0-1.5h.75zm.75 7.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12 17.799 22.5 12 22.5zm0-1.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0-12a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z"
  }));
};

InfoIcon.displayName = 'InfoIcon';
export default InfoIcon;